// extracted by mini-css-extract-plugin
export default {"containerBenefit":"BenefitComp_containerBenefit__ALIMo","benefitTitle":"BenefitComp_benefitTitle__Qyt0j","benefitText":"BenefitComp_benefitText__R7K0J"};